    <ng-select #ngCategory [items]="companyCategoryService.Categories$ | async" bindLabel="categoryName" (change)="categoryChange($event)"
        bindValue="categoryName" [formControl]="control" [placeholder]="'Select an option'">
    </ng-select>
    <app-form-errors [control]="control" fieldName="Category"></app-form-errors>